import axios from 'axios';

async function updateCompanyDocument(companyId, documentName, data) {
  const response = await axios.post(`/companies/${companyId}/documents?document=${documentName}`, data);

  return response.data;
}

const documentService = {
  updateCompanyDocument,
}

export default documentService;
